/* Collège des Bernardins — copie du code jeune, barre d'inscription mobile, limite à 1 place par cours */
(function () {
  // Les libellés du bouton (window.variantStrings) sont encodés en HTML par Shopify
  // (S&#39;inscrire) puis réinjectés en texte brut par Dawn : on les décode.
  (function decodeVariantStrings() {
    var o = window.variantStrings;
    if (!o) return;
    var d = document.createElement('textarea');
    Object.keys(o).forEach(function (k) {
      if (typeof o[k] === 'string' && o[k].indexOf('&') > -1) { d.innerHTML = o[k]; o[k] = d.value; }
    });
  })();

  // Copie du code promo
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cb-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-cb-copy');
    var action = btn.querySelector('.cb-code__action');
    var done = function () {
      if (!action) return;
      var initial = action.getAttribute('data-initial') || action.textContent;
      action.setAttribute('data-initial', initial);
      action.textContent = 'Copié ✓';
      setTimeout(function () { action.textContent = initial; }, 2200);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, done);
    } else {
      var t = document.createElement('textarea');
      t.value = code; document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(t); done();
    }
  });

  // Barre d'inscription fixe
  function initSticky() {
    var bar = document.querySelector('[data-cb-sticky]');
    if (!bar) return;
    var formId = bar.getAttribute('data-form-id');
    var form = document.getElementById(formId);
    var mainBtn = form ? form.querySelector('[name="add"]') : null;
    if (!mainBtn) return;
    var stickyBtn = bar.querySelector('[data-cb-sticky-button]');
    var priceEl = bar.querySelector('.cb-sticky-atc__price');
    var sectionId = formId.replace('product-form-', '');
    var mq = window.matchMedia('(max-width: 749px)');

    function sync() {
      stickyBtn.disabled = mainBtn.disabled;
      var label = mainBtn.querySelector('span');
      if (label && label.textContent.trim()) stickyBtn.textContent = label.textContent.trim();
      var price = document.querySelector('#price-' + sectionId + ' .price');
      if (price && priceEl) {
        var sale = price.classList.contains('price--on-sale') ? price.querySelector('.price-item--sale') : null;
        var reg = price.querySelector('.price__regular .price-item--regular');
        var txt = (sale || reg || price).textContent.trim();
        if (txt) priceEl.textContent = txt;
      }
    }
    function show(on) {
      bar.classList.toggle('is-visible', on);
      document.body.classList.toggle('cb-sticky-on', on);
    }
    var io = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      show(mq.matches && passed);
    });
    io.observe(mainBtn);
    new MutationObserver(sync).observe(form, { subtree: true, attributes: true, childList: true, characterData: true });
    var priceWrap = document.getElementById('price-' + sectionId);
    if (priceWrap) new MutationObserver(sync).observe(priceWrap, { subtree: true, childList: true, characterData: true });
    stickyBtn.addEventListener('click', function () {
      if (mainBtn.disabled) return;
      mainBtn.click();
    });
    sync();
  }

  // Une seule place par cours dans le panier (reprise du thème précédent)
  function limitQuantities() {
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (input.matches && input.matches('input[type="number"][name="updates[]"], input.quantity__input') && Number(input.value) > 1) {
        input.value = 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        alert("Vous ne pouvez ajouter qu'une seule unité de chaque produit à votre panier.");
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initSticky(); limitQuantities(); });
  } else { initSticky(); limitQuantities(); }
})();
